var form = $("#maskForm");
var buttonSubmit = $("#myButton");
var buttonLoader = $("#flash");
var inputServer = $("#server");
var inputPort = $("#port");

function scanPort(portNumber) {
	inputPort.val(portNumber);
	buttonSubmit.click();
}

$(function () {
	form.on('submit', function (e) {
		e.preventDefault();
		e.stopImmediatePropagation();

		buttonSubmit.click();
	});

	buttonSubmit.on('click', function () {
		buttonSubmit.hide(); //bring back load more button
		buttonLoader.show();
		buttonLoader.fadeIn(400).html('<button class="btn btn-danger" disabled><span class="spinner-grow spinner-grow-sm"></span>	Scannen im Gange..</button>');


		$.ajax({
			type: "POST",
			url: "/inc/open-port-check-process.php",
			data: {
				server: inputServer.val(),
				port: inputPort.val(),
			},
			cache: false,
			success: function (html) {
				$("ol#update").prepend(html);
				$("ol#update li:first").slideDown("slow");
				buttonLoader.hide();
				buttonSubmit.show();
			}
		});

		return false;
	});
});



$(function () {
	$("#quick").click(function () {
		var server = $("#server").val();
		var dataString = 'server=' + server;

		$("#myButton").hide(); //bring back load more button
		$("#flash").show();

		$("#flash").fadeIn(400).html('<button class="btn btn-danger" disabled><span class="spinner-grow spinner-grow-sm"></span>	Scannen im Gange..</button>');

		$.ajax({
			type: "POST",
			url: "/inc/quick-scan-port.php",
			data: dataString,
			cache: false,
			success: function (html) {
				$("ol#update").prepend(html);
				$("ol#update li:first").slideDown("slow");
				$("#flash").hide();
				$("#myButton").show();
			}
		});
		return false;
	});
});



$(function () {
	$("#long").click(function () {
		var server = $("#server").val();
		var dataString = 'server=' + server;

		$("#myButton").hide(); //bring back load more button
		$("#flash").show();
		$("#flash").fadeIn(400).html('<button class="btn btn-danger" disabled><span class="spinner-grow spinner-grow-sm"></span>	Scannen im Gange..</button>');

		$.ajax({
			type: "POST",
			url: "/inc/long-scan-port.php",
			data: dataString,
			cache: false,
			success: function (html) {
				$("ol#update").prepend(html);
				$("ol#update li:first").slideDown("slow");
				$("#flash").hide();
				$("#myButton").show();
			}
		});
		return false;
	});
});



$(function () {
	$("#game").click(function () {
		var server = $("#server").val();
		var dataString = 'server=' + server;

		$("#myButton").hide(); //bring back load more button
		$("#flash").show();
		$("#flash").fadeIn(400).html('<button class="btn btn-danger" disabled><span class="spinner-grow spinner-grow-sm"></span>	Scannen im Gange..</button>');

		$.ajax({
			type: "POST",
			url: "/inc/game-scan-port.php",
			data: dataString,
			cache: false,
			success: function (html) {
				$("ol#update").prepend(html);
				$("ol#update li:first").slideDown("slow");
				$("#flash").hide();
				$("#myButton").show();
			}
		});
		return false;
	});
});
